'use client'
import React from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  WhatsappIcon,
  TelegramIcon,
} from 'react-share'

interface ShareButtonsProps {
  slug: string
  displayId: string | number
  title: string
  heroImageUrl?: string
}

export const ShareButtons: React.FC<ShareButtonsProps> = ({
  slug,
  displayId,
  title,
  heroImageUrl,
}) => {
  // Compute the base URL: use window.location.origin on client side
  const baseUrl =
    typeof window !== 'undefined' ? window.location.origin : process.env.NEXT_PUBLIC_BASE_URL || ''

  const fullUrl = `${baseUrl}/${slug}/${displayId}`

  // Fix hero image URL - convert from /api/media/file/... to /resimler/...
  const fixedHeroImageUrl = heroImageUrl
    ? heroImageUrl.replace('/api/media/file/', '/resimler/')
    : ''

  // Make sure the image URL is absolute
  const absoluteImageUrl = fixedHeroImageUrl
    ? fixedHeroImageUrl.startsWith('http')
      ? fixedHeroImageUrl
      : `${baseUrl}${fixedHeroImageUrl}`
    : ''

  // Icon size: 32px is default for react-share, but we want 32px and round for visual match
  const iconSize = 32
  const iconRound = true
  return (
    <div className="flex items-center gap-2">
      <span className="text-slate-700 text-sm font-medium mr-1">PAYLAŞ</span>
      {/* Facebook */}
      <FacebookShareButton url={fullUrl}>
        <FacebookIcon size={iconSize} round={iconRound} />
      </FacebookShareButton>
      {/* Twitter/X */}
      <TwitterShareButton url={fullUrl} title={title}>
        <TwitterIcon size={iconSize} round={iconRound} />
      </TwitterShareButton>
      {/* LinkedIn */}
      <LinkedinShareButton url={fullUrl} title={title}>
        <LinkedinIcon size={iconSize} round={iconRound} />
      </LinkedinShareButton>
      {/* Pinterest */}
      <PinterestShareButton url={fullUrl} media={absoluteImageUrl} description={title}>
        <PinterestIcon size={iconSize} round={iconRound} />
      </PinterestShareButton>
      {/* WhatsApp */}
      <WhatsappShareButton url={fullUrl} title={title}>
        <WhatsappIcon size={iconSize} round={iconRound} />
      </WhatsappShareButton>
      {/* Telegram */}
      <TelegramShareButton url={fullUrl} title={title}>
        <TelegramIcon size={iconSize} round={iconRound} />
      </TelegramShareButton>
    </div>
  )
}
